import { type RefObject, useCallback, useState } from "react";

import { useResizeObserver } from "../../hooks/use-resize-observer";
import { modalDivClassName } from "./modal-view";

export const useTopmostModalSize = (modalsContainerRef: RefObject<HTMLElement | null>): [{ height: number; width: number }, () => void] => {
  const [size, setSize] = useState({ height: 0, width: 0 });

  const updateTopmostModalSize = useCallback(() => {
    if (!modalsContainerRef.current) {
      return;
    }

    const activeModals = [...modalsContainerRef.current.querySelectorAll("& > [data-transition-item-key]")].filter(
      (element) => element.getAttribute("data-leave") === null,
    ) as HTMLDivElement[];

    if (activeModals.length === 0) {
      return;
    }

    const topmostModal = activeModals[activeModals.length - 1]!;
    const contentDiv = topmostModal.querySelector(`.${modalDivClassName}`) as HTMLDivElement | null;

    if (!contentDiv) {
      return;
    }

    setSize({
      height: contentDiv.offsetHeight,
      width: contentDiv.offsetWidth,
    });
  }, [modalsContainerRef]);

  useResizeObserver(modalsContainerRef.current, updateTopmostModalSize);

  return [size, updateTopmostModalSize];
};
